import get from 'lodash/get';
import striptags from 'striptags';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');
  const wpPage = get(state, 'customPage.data.page[0]');
  const slug = get(wpPage, 'slug');
  const pageTitle = get(wpPage, 'title.rendered');
  const wpExcerpt = get(wpPage, 'excerpt.rendered');
  let description = wpExcerpt ? striptags(wpExcerpt).trim() : '';
  let title = `${siteHumanReadable}` || '';

  if (slug === 'most-innovative-companies') {
    title = '2018 Most Innovative Companies | Fast Company';
    description =
      "Receive a verified company bio page on Fastcompany.com and receive automatic entry into Fast Company's influencer community, plus appear in the March 2018 issue of our magazine.";
  }

  const data = baseSeoUtil({
    site,
    siteConf,
    title,
    url: `https://www.${site}.com/${slug}`,
    description,
    articleSection: pageTitle
  });

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/wp_page_seo_util.js